import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  colors,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { GoSearch } from "react-icons/go";
import { axiosInstance } from "../../../axiosInstance";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const columns = [
  { id: "name", label: "MEDICINE NAME", minWidth: 100, align: "center" },
  { id: "type", label: "MEDICINE TYPE", minWidth: 170, align: "center" },
  { id: "ptr", label: "PTR", minWidth: 170, align: "center" },
  { id: "mrp", label: "MRP", minWidth: 170, align: "center" },
  { id: "pack", label: "PACK", minWidth: 170, align: "center" },
  { id: "brand_name", label: "BRAND NAME", minWidth: 170, align: "center" },
  { id: "created_at", label: "CREATED AT", minWidth: 170, align: "center" },
  { id: "actions", label: "ACTIONS", minWidth: 100, align: "center" },
];

function createData(name, type) {
  return { name, type };
}

const rows = [
  createData("Paracetamol", "Medicine"),
  createData("Product Name", "Surgical"),
  createData("Paracetamol", "Medicine"),
  createData("Product Name", "Surgical"),
  createData("Paracetamol", "Medicine"),
];

export const EditMedicine = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [medicineList, setMedicineList] = useState([]);
  const [toggleModalOpen, setToggleModalOpen] = useState(false);
  const [toggleTarget, setToggleTarget] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const WholesalerId = localStorage.getItem("wholesaler_ID") || "";
  console.log("Wholesaler Id for Medicine List:", WholesalerId);

  const fetchMedicineList = async () => {
    if (!WholesalerId) {
      setMedicineList([]);
      return;
    }

    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(
        `/admin/wholesaler-medicine?wholesaler_id=${WholesalerId}`,
      );
      console.log("✅ Medicine list response:", res.data);
      if (res.data.status === "success" && Array.isArray(res.data.data)) {
        const formattedData = res.data.data.map((item) => ({
          id: item.wholesaler_medicine_id,
          name: item.master_medicine?.name || "--",
          type: item.master_medicine?.type
            ? item.master_medicine.type.charAt(0).toUpperCase() +
              item.master_medicine.type.slice(1)
            : "--",
          ptr: item.ptr ?? "--",
          mrp: item.mrp ?? "--",
          pack: item.pack?.trim() ? item.pack : "--",
          brand_name: item.brand_name?.trim() ? item.brand_name : "--",
          created_at: item.master_medicine?.created_at
            ? new Date(item.master_medicine.created_at).toLocaleDateString()
            : "--",
          stock: item.stock ?? false,
        }));
        setMedicineList(formattedData);
      } else {
        setError("Failed to fetch Medicine data.");
      }
    } catch (err) {
      console.error("❌ Error fetching Medicine data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMedicineList();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleToggleStatus = async () => {
    if (!toggleTarget) return;

    try {
      const res = await axiosInstance.patch(
        `/admin/wholesaler-medicine/${toggleTarget.id}/`,
        {
          stock: !toggleTarget.stock,
        },
      );
      if (res.data.status === "success") {
        toast.success("Medicine stock status updated successfully");
        fetchMedicineList();
        setToggleModalOpen(false);
      } else {
        toast.error("Failed to update stock status");
      }
    } catch (err) {
      console.error("❌ Error updating stock:", err);
      toast.error("Error updating stock status");
    }
  };

  // add medicine modal
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    setFile(null);
    setUploadType("");
    setMedicineName("");
    setBrandName("");
    setPtr("");
    setPack("");
  };

  const handleShow = () => setShow(true);
  const [uploadType, setUploadType] = useState("");

  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = [
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    ];

    if (!allowedTypes.includes(selectedFile.type)) {
      toast.error("Only Excel files (.xls, .xlsx) are allowed");
      e.target.value = null; // reset input
      return;
    }

    setFile(selectedFile);
  };
  const [medicineName, setMedicineName] = useState("");
  const [brandName, setBrandName] = useState("");
  const [ptr, setPtr] = useState("");
  const [mrp, setMrp] = useState("");
  const [pack, setPack] = useState("");
  // const [stock, setStock] = useState("");

  const handleUpload = async () => {
    if (uploadType === "single") {
      if (!medicineName || !ptr || !mrp) {
        toast.error("Medicine Name, PTR and MRP are required!");
        return;
      }
    }
    if (uploadType === "bulk") {
      if (!file) {
        toast.error("Please upload an Excel file!");
        return;
      }
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("wholesaler_id", WholesalerId);

    formData.append("name", medicineName);
    formData.append("brand_name", brandName);
    formData.append("ptr", ptr);
    formData.append("mrp", mrp);
    formData.append("pack", pack);

    try {
      setLoader(true);
      const response = await axiosInstance.post(
        "/admin/wholesaler-medicine-create/",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );
      if (response.data.status === "success" || response.status === 200) {
        toast.success(response.data.message || "Uploaded successfully!");
        fetchMedicineList();
        setFile(null); // reset after upload
        handleClose();
      }
    } catch (err) {
      console.error("Upload failed:", err);
      toast.error(err.response.data.message || "Upload failed!");
    } finally {
      setLoader(false);
    }
  };
  return (
    <>
      {loader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "#1265c5" }} />
          </Stack>
        </div>
      )}
      <div>
        <div className="admin-top-container">
          <div className="admin-listText">{""}</div>
          <div>{""}</div>
          <div className="search-container">{""}</div>
          {/* <div className="btnAdd">
          <button onClick={() => navigate("/manage-wholesaler-addmedicine")}>
            + Add Medicine
          </button>
        </div> */}
          <div className="btnAdd">
            <button onClick={handleShow}>+ Add Medicine</button>
          </div>
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : medicineList.length > 0 ? (
                  medicineList
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        className="table-row"
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                        sx={{
                          backgroundColor:
                            index % 2 === 1 ? "#E7F0F9" : "white",
                        }}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              className={`${column.id}-column tableCelldata`}
                              sx={{
                                color:
                                  column.id === "status"
                                    ? value === "Active"
                                      ? "green"
                                      : "red"
                                    : "inherit",
                              }}
                            >
                              {column.id === "actions" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: "8px",
                                  }}
                                >
                                  {/* <IconButton sx={{ color: "black" }}>
                                  <EditIcon
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "18px",
                                    }}
                                    onClick={() =>
                                      navigate(
                                        "/manage-wholesaler-editeachmedicine"
                                      )
                                    }
                                  />
                                </IconButton> */}
                                  {/* <IconButton sx={{ color: "black" }}>
                                  <DeleteIcon style={{ fontSize: "18px" }} />
                                </IconButton> */}
                                  <div
                                    className="form-check form-switch"
                                    style={{ marginTop: "5px" }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`toggleSwitch-${row.id}`}
                                      checked={row.stock}
                                      onChange={() => {
                                        setToggleTarget(row);
                                        setToggleModalOpen(true);
                                      }}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`toggleSwitch-${row.id}`}
                                    ></label>
                                  </div>
                                </div>
                              ) : (
                                value
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      align="center"
                      style={{ padding: "40px 0" }}
                    >
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[
              20, 40, 100, 150, 200, 300, 400, 500, 1000, 1500, 2000, 3000,
            ]}
            component="div"
            count={medicineList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>

      <Modal
        show={toggleModalOpen}
        onHide={() => setToggleModalOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="toggle-status-title">Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Do you want to {toggleTarget?.stock ? "INACTIVATE" : "ACTIVATE"}{" "}
            this Medicine?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setToggleModalOpen(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleToggleStatus}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      {/* add medicine modal  */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="wholesaler-addmedicine-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Choose Upload Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="whole-modal-radio">
            <span>
              <input
                type="radio"
                name="upload"
                onChange={() => setUploadType("single")}
              />
              <label className="ms-1">Single</label>
            </span>
            <span>
              <input
                type="radio"
                name="upload"
                onChange={() => setUploadType("bulk")}
              />
              <label className="ms-1">Bulk</label>
            </span>
          </div>
          {uploadType === "single" && (
            <>
              <div className="whole-modal-single-container">
                <div className="single-container-text">
                  <label>
                    Medicine Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Medicine Name"
                    onChange={(e) => setMedicineName(e.target.value)}
                  />
                </div>
                <div className="single-container-text">
                  <label>Brand Name</label>
                  <input
                    type="text"
                    placeholder="Enter Brand Name"
                    onChange={(e) => setBrandName(e.target.value)}
                  />
                </div>
                <div className="single-container-text">
                  <label>
                    PTR <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter PTR"
                    onChange={(e) => setPtr(e.target.value)}
                  />
                </div>
                <div className="single-container-text">
                  <label>
                    MRP <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter MRP"
                    onChange={(e) => setMrp(e.target.value)}
                  />
                </div>
                <div className="single-container-text mb-4">
                  <label>Pack</label>
                  <input
                    type="text"
                    placeholder="Enter Pack"
                    onChange={(e) => setPack(e.target.value)}
                  />
                </div>
              </div>
              {/* <div className="whole-modal-stock">
                <span>
                  <input
                    type="radio"
                    name="stock"
                    onChange={() => setStock("instock")}
                  />
                  <label className="ms-1">In Stock</label>
                </span>
                <span>
                  <input
                    type="radio"
                    name="stock"
                    onChange={() => setStock("outstock")}
                  />
                  <label className="ms-1">Out Of Stock</label>
                </span>
              </div> */}
              <Modal.Footer>
                <Button className="btnFileModalCancel" onClick={handleClose}>
                  Cancel
                </Button>
                <Button onClick={handleUpload}>Confirm Upload</Button>
              </Modal.Footer>
            </>
          )}
          {uploadType === "bulk" && (
            <div>
              <div className="mb-4">
                <input
                  type="file"
                  onChange={handleFileChange}
                  accept=".xls,.xlsx"
                />
              </div>
              <Modal.Footer>
                <Button className="btnFileModalCancel" onClick={handleClose}>
                  Cancel
                </Button>
                <Button onClick={handleUpload}>Confirm Upload</Button>
              </Modal.Footer>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
